module.exports = __webpack_public_path__ + "static/media/1@3x.e0e687b5.png";